export default __webpack_public_path__ + "static/media/mercedes-benz.543b7283.svg";